<template>
    <div class="lookup-container" style="display: flex;">
        <v-combobox                 
            label="Outcome" 
            :items="outcomes"
            :value="typeof value === 'string' ? JSON.parse(value).outcome : null"
            @input="emitOutcome($event)"
            solo flat 
            >
        </v-combobox>
        <div style="display: flex; align-items: center; padding: 0 15px;"> by </div>
        <party-reference
        :value="typeof value ==='string' ? JSON.parse(value).party : null"
        @input="emitParty($event)"
        ></party-reference>
    </div>
</template>
<script>
import axios from 'axios'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

import PartyReference from './PartyReference.vue';

export default {
    props: ['value'],
    data() {
        return ({            
            outcomes: ['Won', 'Lost']
        })
    },
    components: {
        PartyReference
    },
    methods: {
        emitOutcome($event) {
            this.$emit('input', JSON.stringify({...JSON.parse(this.value), outcome: $event}));
        },
        emitParty($event) {
            this.$emit('input', JSON.stringify({...JSON.parse(this.value), party: $event}));
        }
    }
}
</script>